import Point_Of_Sale from './components/Point_Of_Sale';

export default Point_Of_Sale;